module.exports = __webpack_public_path__ + "static/img/jiangbei.a7d03e36.png";